module.exports = __webpack_public_path__ + "img/area7_211021.37f75761.jpg";